<template>
  <div style="height: 100%; width: 100%;" :class="{lightGoldTheme:level>=3, lightSilverTheme:level==2, lightCopperTheme:level==1, lightStandardTheme:level==0, }">
    <!--
    <popup :width="'40vw'" :height="'16vw'" v-if="showErrorPanel && screenWidth>767" @close="showErrorPanel=false">
      <user-modif @deleteWord="deleteWord" :word="word"
                   :level="currentShow.difficulty_level" @close="showErrorPanel=false"></user-modif>
    </popup>
    <popup :width="'80vw'" :height="'100vw'" v-else-if="showErrorPanel" @close="showErrorPanel=false">
      <user-modif @deleteWord="deleteWord" :word="word"
                  :level="currentShow.difficulty_level" @close="showErrorPanel=false"></user-modif>
    </popup>
    -->

    <div id="cardGrid" class="centercenter" :class="{blurAll: showErrorPanel}">
      <!--
      <div id="tools">
        <i class="fas fa-exclamation-triangle" @click="showErrorPanel = !showErrorPanel"
           title="Signaler une erreur !"></i>
      </div>
      -->
      <transition name="fadered" mode="out-in">
        <div id="word" class="centercenter" :key="word.lemma.english" @click="textToSpeech(englishWord)">
          <div id="english">

            {{englishWord}}
            <i class="fas fa-volume-down clickable" style="font-size: 50%; top: 0.5vw; right:0; position: absolute"></i>
          </div>
          <div id="equals" :class="{darkGoldTheme:level>=3, darkSilverTheme:level==2, darkCopperTheme:level==1, darkStandardTheme:level==0, }">=</div>
          <div id="french" class="centercenter"><!-- class="centercenter bigPaddingRound mediumRoundAngles"
              >-->
            <div id="trad" class="centercenter">
              {{ word.lemma.separateTrads[0] }}
            </div>
            <div id="othertrad" class="flexwrap centercenter">
              {{ word.lemma.separateTrads[1] }}
            </div>
          </div>

          <!--<subtitles style="align-self: flex-end"></subtitles>-->

        </div>
      </transition>
      <div class="startbutton clickable flexwrap centercenter clickable blue" @click="nextClicked()"
           :style="styleObject">
        Next
      </div>

      <!--<div id="sentence">
            <span v-for="(word, index) in sentence" :key="index">
                <span :class="{originalWord : isOriginalWord(word)}">{{ word }}&thinsp;</span>
            </span>
      </div>-->
    </div>
  </div>


</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import textToSpeech from '../plugins/texttospeech'
import Vue from 'vue'
Vue.use(textToSpeech)

export default {
  name: "vocabularyCardWord",

  components: {Popup: () => import(/* webpackPrefetch: true */ '@/components/popup.vue'),
    userModif: () => import(/* webpackPrefetch: true */ '@/components/userModif.vue'),
    subtitles: () => import(/* webpackPrefetch: true */ '@/components/subtitles')},

  props: {
    //wordNumValue: Number,
    voicesListValue: Array,
    vocab: Array,
    wordToDisplay: {
      type: Object,
      required: false
    }
  },
  created() {
    if(!this.displayWord) {
      this.set_currentWord(this.vocab[this.wordNum - 1]);
    }

    // window.addEventListener("keydown", this.getKey);

    //speech
    if (this.$cookies.get('autoSpeech') == 1) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      this.textToSpeech(this.englishWord)
    }
  },
  mounted() {
    this.nextIsOk();
  },
  destroyed() {
    if(!this.displayWord) {
      this.set_currentWord(null);
    }
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'apiData',
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
      'currentShow',
    ]),
    ...mapGetters('session', [
      'wordNum',
      'testNum',
      'currentComponent',
      'sessionWordsList',
      'currentWord',
      'displayWord',
      'learntWords'
    ]),
    word: function () {
      return this.currentWord;
    },
    englishWord: function () {
      return this.word.lemma.decenglish
    },

    styleObject: function () {
      return {
        '--color': this.currentShow.color
      }
    },
    definition: function () {
      if (this.word.lemma.definition) {
        let sentence = this.word.lemma.definition.trim();
        sentence = sentence[0].toUpperCase() +
            sentence.slice(1);

        let laststchar = sentence.charAt(sentence.length - 1);
        if (!laststchar.match(/^[.,:!?]/)) {
          sentence = sentence + "";
        }
        // On sépare les définitions, on les limite à 3 et on ajoute une majuscule en début
        let sentenceTab = sentence.split('; ');
        sentenceTab.splice(3, sentenceTab.length - 3);
        for (let i = 0; i < sentenceTab.length; i++) {
          let temp1 = sentenceTab[i].substring(0, 1).toUpperCase();
          let temp2 = sentenceTab[i].substring(1);
          sentenceTab[i] = temp1 + temp2;
        }
        return sentenceTab;
      } else {
        return [""];
      }

    },
    sentence: function () {
      let sentence = this.word.first_sentence.sentence.trim();
      let firstchar = sentence.charAt(0);
      if (firstchar !== firstchar.toUpperCase()) {
        sentence = "... " + sentence;
      }
      let laststchar = sentence.charAt(sentence.length - 1);
      if (!laststchar.match(/^[.!?]/)) {
        sentence = sentence + " ...";
      }
      // On définit un nombre de character maximum pour la phrase contextuelle.
      // Si la phrase contextuelle dépasse le nombre de character on applique l'algorithme suivant
      let maxChars = 100;
      return this.centerLemma(maxChars, sentence);
    },
    level: function () {
      if (this.word.lemma.user_lemma.length > 0) {
        return this.word.lemma.user_lemma[0].knowledge_level
      }
      return 0
    },
  },

  methods: {
    ...mapActions('session', [
      'add_learntWord',
        'set_currentWord'
    ]),
    textToSpeech(word) {
      /*this.$textToSpeech(word)*/
      let currentUrl = ''
      let currentVoice = "Matthew"
      if(this.voice===1){
        currentUrl = this.url1
      }
      else{
        currentUrl = this.url2
        currentVoice = "Salli"
      }

      if(currentUrl == ''){
        // Initialize the Amazon Cognito credentials provider
        AWS.config.region = 'eu-west-3';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({IdentityPoolId: 'eu-west-3:acfb193c-b37d-4ee9-bcbd-209283d4a2ec'});

        var speechParams = {
          OutputFormat: "mp3",
          SampleRate: "22050",
          Text: word,
          TextType: "text",
          VoiceId: currentVoice
        };
        var polly = new AWS.Polly({apiVersion: '2016-06-10'});
        var signer = new AWS.Polly.Presigner(speechParams, polly)

        // Create presigned URL of synthesized speech file
        signer.getSynthesizeSpeechUrl(speechParams, (error, url) => {
          if (!error) {
            if(this.voice===1) {
              this.url1 = url
              this.voice = 2
            }
            else{
              this.url2 = url
              this.voice = 1
            }
            new Audio(url).play();
          }
        })
      }
      else{
        new Audio(currentUrl).play();
        if(this.voice===1){
          this.voice = 2
        }
        else{
          this.voice = 1
        }
      }

    },

    nextIsOk() {
      window.setTimeout(() => this.nextOkValue = true, 300)
    },

    nextClicked() {
      this.nextOkValue = false;
      // On ajoute le mot au tableau des mots en cours d'acquisition si on n'était pas sur un mot en mode display.
      if(!this.displayWord) {
        let wordTemp = Object.assign({}, this.word);
        wordTemp.lemmaCount = 0;
        this.add_learntWord(wordTemp);
      }
      this.$emit('nextClicked');
    },

    deleteWord() {
      if (this.vocab.length > this.wordNum && this.vocab.length > 4) {
        this.sessionWordsList.vocab.splice(this.wordNum - 1, 1);
        this.set_currentWord(this.sessionWordsList.vocab[this.wordNum - 1]);
      }
    },
    getKey(event) {
      switch (event.key) {
        case "ArrowRight" :
          this.nextClicked();
          break
        case "Delete" :
          this.deleteWord();
          break
        case "Escape" :
          this.fastForward();
          break
      }
    },

    centerLemma: function (max_char, sentence) {
      /* On parcourt sentence, mot à mot et on récupère le mot si sa distance au lemme est la plus faible depuis le début */
      // On crée le tableau des mots de sentence
      let wordTabs = sentence.split(/[^A-Za-z^-]/);
      // On crée un tableau des lemmes
      let lemmas = this.word.lemma.english.split(' ');
      // On crée un tableau des futures objects correspondants à un lemme et sa position
      let originalWords = [];
      for (let i = 0; i < lemmas.length; i++) {
        let wordData = {
          word: wordTabs[0],
          pos: 0
        };
        originalWords[i] = wordData;
      }
      // boucle générale de sentence
      for (let i = 0; i < wordTabs.length; i++) {
        // On repère le mot le plus proche dans la phrase
        for (let j = 0; j < lemmas.length; j++) {
          if (this.levenshtein(originalWords[j].word, lemmas[j]) > this.levenshtein(wordTabs[i], lemmas[j])) {
            let wordData = {
              word: wordTabs[i],
              pos: i
            };
            originalWords[j] = wordData;
          }
        }
      }
      this.originalWords = originalWords;

      let posLemma = sentence.search(originalWords[0].word);
      let originalWord = sentence.substring(posLemma, (sentence.search(originalWords[originalWords.length - 1].word) + originalWords[originalWords.length - 1].word.length));
      let sentenceObject = {
        part1: sentence.slice(0, posLemma),
        originalWords: originalWord,
        part2: sentence.slice(posLemma + originalWord.length, sentence.length),
      };

      if (sentence.length > max_char) {
        let startIndex = 0;
        let part1 = '';
        let part2 = '';
        let endIndex = max_char;
        let reste = 0;
        let afterLemme = 0;
        let pre = '';
        let suf = '';

        if (posLemma - Math.floor((max_char - originalWord.length) / 2) <= 0) {
          startIndex = 0;
          endIndex = max_char;
          do {
            endIndex++;
          }
          while (sentence[endIndex] !== " " && endIndex < sentence.length)
        }

        /* S'il y a + de 75 characters avant le lemme, on décalera le startIndex vers la gauche
                  s'il y en a - de 75 à droite du lemme. */


        else {
          pre = '...';
          reste = posLemma - Math.floor((max_char - originalWord.length) / 2);
          afterLemme = sentence.length - (posLemma + originalWord.length);
          if (afterLemme > Math.floor((max_char - originalWord.length) / 2)) {
            startIndex = reste;
          } else {
            startIndex = reste - Math.floor(((max_char - originalWord.length) / 2 - afterLemme));
          }
          endIndex = startIndex + max_char;
          do {
            startIndex--;
          }
          while (sentence[startIndex] !== " " && startIndex > 0)
        }
        if (sentence.length - (posLemma + originalWord.length) > Math.floor((max_char - originalWord.length) / 2)) {
          suf = '...';
        }

        part1 = pre + sentence.slice(startIndex, posLemma);
        part2 = sentence.slice(posLemma + originalWord.length, endIndex) + suf;
        sentenceObject.part1 = part1;
        sentenceObject.part2 = part2;
      }
      let finalSentence = sentenceObject.part1 + sentenceObject.originalWords + sentenceObject.part2;

      return finalSentence.split(' ');
    },
    isOriginalWord: function (word) {
      for (let i = 0; i < this.originalWords.length; i++) {
        if (this.originalWords[i].word === word.replace(/[^a-zA-Z ]/g, "")) {
          return true;
        }
      }
      return false;
    },
    levenshtein: function (a, b) {
      if (a.length === 0) return b.length;
      if (b.length === 0) return a.length;

      var matrix = [];

      // increment along the first column of each row
      var i;
      for (i = 0; i <= b.length; i++) {
        matrix[i] = [i];
      }

      // increment each column in the first row
      var j;
      for (j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
      }

      // Fill in the rest of the matrix
      for (i = 1; i <= b.length; i++) {
        for (j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) == a.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                Math.min(matrix[i][j - 1] + 1, // insertion
                    matrix[i - 1][j] + 1)); // deletion
          }
        }
      }

      return matrix[b.length][a.length];
    }
  },

  watch: {
    'word.lemma.id': function() {
      this.set_currentWord(this.word);
    }
  },

  data() {
    return {
      nextOkValue: false,
      wordtype: {
        'n': 'noun',
        'v': 'verb',
        'adv': 'adverb',
        'adj': 'adjective'
      },
      originalWords: [],
      showErrorPanel: false,
      url1: '',
      url2: '',
      voice: 1,
      screenWidth: window.screen.width
    }
  }
}
</script>

<style scoped>

#cardGrid {
  position: relative;
  width: calc(100% - 4vw);
  height: calc(100% - 4vw);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
  padding: 2vw;
  text-align: center;
}

#tools {
  position: absolute;
  top: 1vw;
  right: 1vw;
  color: #c9c9c9;
  transition-property: color;
  transition-duration: .5s;
}

#tools > i {
  cursor: pointer;
  margin-left: 1.5vw;
}

#tools > i:hover {
  color: #eeeeee;
}

#word {
  grid-row: 1/2;
  grid-column: 1/2;
  display: grid;
  /*grid-template-columns: 1fr 45px calc(50% - 40px - 120px) 80px;*/
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 2vw 1fr;
  width: 100%;
}

#english {
  position: relative;
  grid-column: 1/2;
  grid-row: 1/2;
  font-size: 300%;
  font-weight: bold;
  align-self: flex-end;
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  padding: 0 2vw 0 2vw;
}

#equals {
  grid-column: 1/2;
  grid-row: 2/3;
  font-weight: bold;
  font-size: 300%;
}


#french {
  grid-column: 1/2;
  grid-row: 3/4;
  display: grid;
  /*grid-template-columns: 1fr 45px calc(50% - 40px - 120px) 80px;*/
  grid-template-columns: auto;
  grid-template-rows: auto 1fr;
  align-self: flex-start;
  width: fit-content;
  text-align: center;
  padding: 0 2vw 0 2vw;
}

#trad {
  grid-column: 1/2;
  grid-row: 2/3;
  font-weight: bold;
  font-size: 300%;
}

#othertrad {
  grid-column: 1/2;
  grid-row: 3/4;
  font-size: 150%;
  width: 100%;
}


#sentence {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  font-size: 1.8vw;
  font-weight: bold;
  text-shadow: 0.1vw 0.1vw #000, -0.1vw -0.1vw #000, -0.1vw 0.1vw #000, 0.1vw -0.1vw #000,
  0.15vw 0px #000, -0.15vw -0px #000, -0.15vw 0px #000, 0.15vw -0px #000,
  0px 0.15vw #000, -0px -0.15vw #000, -0px 0.15vw #000, 0px -0.15vw #000;
  position: absolute;
  width: 120%;
  top: calc(75% + 25vh - 2.5vw);
  left: -10%;
  font-family: 'Open Sans';
}

.originalWord {
  color: #59daff;
}


.startbutton {
  grid-column: 1/2;
  grid-row: 2/3;
  width: 10vw;
  height: 2vw;
  font-size: 1.2vw;
  justify-self: center;
  bottom: 15vh;
  left: 25vw;
  border-radius: 5vw;
  text-decoration: none;
  margin-bottom: 2vw;
}

.fadered-enter-active {
  transition: all .5s;
  -webkit-transition: all .5s;
  -ms-transition: all .5s;
}

.fadered-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.fadered-leave-active {
  transition: all .3s;
  -webkit-transition: all .3s;
  -ms-transition: all .3s;
}

.fadered-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(-1vw);
  color: #f9c21e;
}

@media screen and (max-device-width: 767px) {
  #cardGrid {
    height: calc(100% - 8vw);
  }
  #tools {
    top: 3vw;
    right: 3vw;
  }
  .startbutton {
    width: 40vw;
    height: 8vw;
    font-size: 4.8vw;
    border-radius: 5vw;
    text-decoration: none;
    margin-bottom: 4vw;
  }
  #word {
    grid-template-rows: 1fr 8vw 1fr;
  }
  #english {
    padding: 0 6vw 0 6vw;
  }
}
</style>
